import c from './app-spacing.vue';

export default c;
